var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-date-picker',{staticClass:"container-date-picker",attrs:{"multiple":"","no-title":"","first-day-of-week":"1","locale":"es-cl","show-current":false,"weekday-format":_vm.weekDays},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})
}
var staticRenderFns = []

export { render, staticRenderFns }